import React, { useState, useEffect } from "react";
import axios from "axios";

const HomeBlog = () => {
  const [blogs, setBlogs] = useState([]);

  // 📌 Fetch Latest 3 Blogs from API
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("https://api.irfanelectricals.com/api/blog");
        setBlogs(response.data.blogs.slice(0, 3)); // ✅ Show only the latest 3 blogs
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <section id="blog_h" className="p_3 bg_light">
      <div className="container-xl">
        <div className="row about_h1 text-center mb-4">
          <div className="col-md-12">
            <h4 className="col_blue">Our Blog</h4>
            <h1 className="mt-3 mb-0">Latest Blog & Articles</h1>
          </div>
        </div>

        <div className="blog_h1 row">
          {blogs.length > 0 ? (
            blogs.map((blog) => (
              <div className="col-md-4" key={blog.id}>
                <div className="blog_h1i">
                  <div className="grid clearfix">
                    <figure className="effect-jazz mb-0">
                      <a href="#">
                        <img
                          src={`https://api.irfanelectricals.com/uploads/${blog.image}`}
                          alt={blog.name}
                          className="w-100"
                          style={{
                            width: "360px", // ✅ Fixed width
                            height: "280px", // ✅ Fixed height
                            objectFit: "cover", // ✅ Ensures proper image cropping
                            display: "block",
                            margin: "0 auto", // ✅ Centers the image
                          }}
                          onError={(e) => (e.target.src = "https://via.placeholder.com/360x280")}
                        />
                      </a>
                    </figure>
                  </div>
                  <div className="blog_h1i1 shadow_box p-3 bg-white">
                    <h4>{blog.name}</h4>
                    <p>{blog.description.substring(0, 100)}...</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center w-100">
              <p>No blogs available.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HomeBlog;
